import { TransactionUserClient } from '@frontend/transaction/api';
import { TransactionUser, TransactionUserType } from '@frontend/transaction/types';

const isUserId = (userId: string | undefined): userId is string => !!userId;

export const collectTransactionUserIds = (transactionUserIds?: string[] | null, transactionUsers?: Partial<TransactionUser>[] | null): string[] => {
    const wizardUserIds = (transactionUsers ?? []).map((user) => user.user_id).filter(isUserId);

    return [...new Set([...(transactionUserIds ?? []), ...wizardUserIds])];
};

export const syncTransactionUsers = async (
    accountId: string,
    transactionId: string,
    type: TransactionUserType,
    desiredUserIds: string[]
): Promise<TransactionUser[]> => {
    const uniqueUserIds = [...new Set(desiredUserIds.filter(Boolean))];
    const remote = await TransactionUserClient.fetchTransactionUsers({ transaction_id: transactionId, type });
    const remoteUserIds = remote.results.map((user) => user.user_id);

    const usersToAdd = uniqueUserIds.filter((userId) => !remoteUserIds.includes(userId));
    const usersToRemove = remote.results.filter((user) => !uniqueUserIds.includes(user.user_id));

    const addedUsers: TransactionUser[] = [];
    for (const userId of usersToAdd) {
        addedUsers.push(
            await TransactionUserClient.postTransactionUser(accountId, transactionId, {
                user_id: userId,
                type
            })
        );
    }

    for (const user of usersToRemove) {
        await TransactionUserClient.deleteTransactionUser(accountId, transactionId, user.user_id);
    }

    return [...addedUsers, ...remote.results.filter((user) => uniqueUserIds.includes(user.user_id))];
};
